import { Role } from "../_models/role";
import { TabOptions } from "../_models/tab-options";

export function deviceNavOptions(deviceId: string | null, role: Role | undefined | null): TabOptions[] {
  if (!deviceId) return [];
  const options: TabOptions[] = [
    { value: 'details', labelText: 'Details', link: `/device/${deviceId}/details` },
    { value: 'od-calibrations', labelText: 'OD Calibrations', link: `/device/${deviceId}/od-calibrations` },
    { value: 'oxygen-calibrations', labelText: 'O2 Calibrations', link: `/device/${deviceId}/oxygen-calibrations` },
    { value: 'ph-calibrations', labelText: 'pH Calibrations', link: `/device/${deviceId}/ph-calibrations` },
    { value: 'sparging-calibrations', labelText: 'Sparging Calibrations', link: `/device/${deviceId}/sparging-calibrations` },
    { value: 'buffers', labelText: 'Buffers', link: `/device/${deviceId}/buffers` },
    { value: 'fluorescence-channels', labelText: 'Fluorescence Channels', link: `/device/${deviceId}/fluorescence-channels` },
  ];

  if (role === Role.OGI_Super_Administrator) {
    options.splice(1, 0, {
      value: 'messages',
      labelText: 'Messages',
      link: `/device/${deviceId}/messages`,
    });
  }

  return options;
}